// src/pages/AllMetricsPage.js
import React from 'react';
import ValuationMetricsCard from '../components/ValuationMetricsCard';
import EarningsQualityCard from '../components/EarningsQualityCard';
import EfficiencyPerformanceMetrics from '../components/EfficiencyPerformanceMetrics';
import LeverageSolvencyMetrics from '../components/LeverageSolvencyMetrics';
import ProfitabilityValuationMetrics from '../components/ProfitabilityValuationMetrics';
import Metrics from '../components/Metrics';
import MetricRatio from '../components/MetricRatio';
import MoreMetricsRatio from '../components/MoreMetricRatio';
import AnalystRatings from '../components/AnalystRatings';
import SectorBenchmarks from '../components/SectorBenchmarks';
import EarningsTrend from '../components/EarningsTrend';

const AllMetricsPage = ({
  selectedCompany,
  stockSymbol,
  selectedQuarter,
  incomeMetrics,
  balanceMetrics,
  cashflowMetrics,
  efficiencyMetrics,
  leverageMetrics,
  profitabilityMetrics,
  valuationMetrics,
  earningsQualityMetrics,
}) => {
  return (
    <div className="w-full">
      <div className="max-w-7xl mx-auto px-4 py-4 space-y-6">
        {/* Market context row — Earnings + Analyst + Sector */}
        {stockSymbol && (
          <div className="grid grid-cols-1 xl:grid-cols-3 gap-4">
            <div className="min-w-0">
              <EarningsTrend stockSymbol={stockSymbol} companyName={selectedCompany} />
            </div>
            <div className="min-w-0">
              <AnalystRatings stockSymbol={stockSymbol} />
            </div>
            <div className="min-w-0">
              <SectorBenchmarks stockSymbol={stockSymbol} companyName={selectedCompany} />
            </div>
          </div>
        )}

        {/* Valuation card - full width at the top */}
        <div className="w-full">
          <ValuationMetricsCard
            selectedCompany={selectedCompany}
            stockSymbol={stockSymbol}
            metricsData={valuationMetrics}
          />
        </div>

        {/* Earnings Quality card - full width */}
        <div className="w-full">
          <EarningsQualityCard
            selectedCompany={selectedCompany}
            stockSymbol={stockSymbol}
            metricsData={earningsQualityMetrics}
          />
        </div>

        {/* Advanced Metrics */}
        <div className="grid grid-cols-1 xl:grid-cols-3 gap-4">
          <div className="min-w-0">
            <EfficiencyPerformanceMetrics
              selectedCompany={selectedCompany}
              stockSymbol={stockSymbol}
              selectedQuarter={selectedQuarter}
              metricsData={efficiencyMetrics}
            />
          </div>
          <div className="min-w-0">
            <LeverageSolvencyMetrics
              selectedCompany={selectedCompany}
              stockSymbol={stockSymbol}
              selectedQuarter={selectedQuarter}
              metricsData={leverageMetrics}
            />
          </div>
          <div className="min-w-0">
            <ProfitabilityValuationMetrics
              selectedCompany={selectedCompany}
              stockSymbol={stockSymbol}
              selectedQuarter={selectedQuarter}
              metricsData={profitabilityMetrics}
            />
          </div>
        </div>

        {/* Basic Metrics beneath */}
        <div className="grid grid-cols-1 xl:grid-cols-3 gap-4">
          <div className="min-w-0">
            <Metrics
              selectedCompany={selectedCompany}
              stockSymbol={stockSymbol}
              selectedQuarter={selectedQuarter}
              metricsData={incomeMetrics}
            />
          </div>
          <div className="min-w-0">
            <MetricRatio
              selectedCompany={selectedCompany}
              stockSymbol={stockSymbol}
              selectedQuarter={selectedQuarter}
              metricsData={balanceMetrics}
            />
          </div>
          <div className="min-w-0">
            <MoreMetricsRatio
              selectedCompany={selectedCompany}
              stockSymbol={stockSymbol}
              selectedQuarter={selectedQuarter}
              metricsData={cashflowMetrics}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AllMetricsPage;
